export enum RequestStatusType {
    InProgress = 0,
    Success = 1,
    Error = 2
}
